import api from "src/api/axios";

const createUser = async (input) => {
  return api.post(`/users`, input).then((result) => {
    return result.data;
  });
};

const updateUser = async (input, id) => {
  return api.patch(`/users/${id}`, input).then((result) => {
    return result.data;
  });
};

const updateActiveStatus = async (input, id) => {
  return api.patch(`/users/active-inactive/${id}`, input).then((result) => {
    return result.data;
  });
};

const getUserList = async (params) => {
  const param = new URLSearchParams();

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const value = params[key];
      // Check if the value is not null or undefined or not empty string
      if (value) {
        param.append(key, value);
      }
    }
  }
  return api.get(`/users?${param}`).then((result) => {
    return result.data;
  });
};

const getSingleUser = async (id) => {
  return api.get(`/users/${id}`).then((result) => {
    return result.data;
  });
};

const getSearchedUser = async (urlParams) => {
  const params = new URLSearchParams();
  Object.keys(urlParams).map((key) => {
    if (urlParams[key]) {
      params.append(key, urlParams[key]);
    }
  });

  return api.get(`/users/search?${params}`).then((result) => {
    return result.data;
  });
};

export {
  createUser,
  getUserList,
  getSingleUser,
  updateUser,
  updateActiveStatus,
  getSearchedUser,
};
